import { CustomCellActionsComponent } from '@app/components/shared/grids/custom-cell-actions/custom-cell-actions.component';
import { TabNames } from '@models/enums/TabNames';
import { ColDef, ICellRendererParams } from 'ag-grid-enterprise';

export const ACCOUNT_COMPANIES_GRID_COLUMNS: ColDef[] = [
    {
        colId: 'id',
        field: 'id',
        headerName: 'ID',
        width: 100,
        lockPinned: true,
        lockPosition: 'left',
        suppressSizeToFit: true,
        cellRenderer: (params: ICellRendererParams) => {
            if (params.value) {
                const link = `/companies-single/${params.value}/${TabNames[TabNames.Overview]}`;
                return `<a class="anchor" href="${link}">${params.value}</a>`;
            }
            return '';
        }
    },
    {
        colId: 'name',
        field: 'name',
        headerName: 'Name',
        sortable: true,
        cellDataType: 'text'
    },
    {
        colId: 'fullAddress',
        field: 'fullAddress',
        headerName: 'Main Office Address',
        sortable: false,
        cellDataType: 'text'
    },
    {
        colId: 'contactFullName',
        field: 'contactFullName',
        headerName: 'Main Contact',
        sortable: true,
        tooltipField: 'contactFullName',
        cellDataType: 'text'
    },
    {
        colId: 'companyTypeName',
        field: 'companyTypeName',
        headerName: 'Type',
        sortable: true,
        cellDataType: 'text'
    },
    {
        colId: 'markets',
        field: 'markets',
        headerName: 'Markets',
        sortable: true,
        cellDataType: 'text'
    },
    {
        colId: 'actions',
        headerName: '',
        maxWidth: 80,
        sortable: false,
        filter: false,
        resizable: false,
        suppressHeaderMenuButton: true,
        suppressSizeToFit: true,
        cellRenderer: CustomCellActionsComponent,
        cellClass: 'action-cell'
    }
];
